import { render, staticRenderFns } from "./TalkMsgEvent.vue?vue&type=template&id=6a10140d&scoped=true"
import script from "./TalkMsgEvent.vue?vue&type=script&lang=js"
export * from "./TalkMsgEvent.vue?vue&type=script&lang=js"
import style0 from "./TalkMsgEvent.vue?vue&type=style&index=0&id=6a10140d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10140d",
  null
  
)

export default component.exports